//encodes unicode string to base64 string
function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(_match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
}

export default b64EncodeUnicode;